import moment from "moment";
import { CreateGlobalScope as CreateGlobalScope } from "./GlobalScope";
import numbro from "numbro";
import numbroSwedish from "numbro/languages/sv-SE";

numbro.registerLanguage(numbroSwedish, true);
CreateGlobalScope();

window["numbro"] = numbro;
